// language=GraphQL
export const ALL_API_KEYS_QUERY = `query Query($withRole: Boolean = false, $withRolePermissions: Boolean = false) {
  apiKeys: apiKeys {
    id
    name
    key
    role @include(if: $withRole) {
      id
      name
      description
      permissions @include(if: $withRolePermissions) {
        id
        path
        module
        name
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_API_KEY_QUERY = `query Query($id: ID!, $withRole: Boolean = false, $withRolePermissions: Boolean = false) {
  apiKey: apiKey(id: $id) {
    id
    name
    key
    role @include(if: $withRole) {
      id
      name
      description
      permissions @include(if: $withRolePermissions) {
        id
        path
        module
        name
      }
    }
  }
}`

// language=GraphQL
export const CREATE_API_KEY_MUTATION = `
  mutation Mutation($input: CreateApiKeyInput, $withRole: Boolean = false, $withRolePermissions: Boolean = false) {
    apiKey: createApiKey(input: $input) {
      id
      name
      key
      role @include(if: $withRole) {
        id
        name
        description
        permissions @include(if: $withRolePermissions) {
          id
          path
          module
          name
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_API_KEY_MUTATION = `
  mutation Mutation($input: UpdateApiKeyInput, $withRole: Boolean = false, $withRolePermissions: Boolean = false) {
    apiKey: updateApiKey(input: $input) {
      id
      name
      key
      role @include(if: $withRole) {
        id
        name
        description
        permissions @include(if: $withRolePermissions) {
          id
          path
          module
          name
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_API_KEY_MUTATION = `
  mutation Mutation($input: DeleteApiKeyInput) {
    deleteApiKey(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_API_KEY_MUTATION = `
  mutation Mutation($input: DeleteApiKeyInput) {
    forceDeleteApiKey(input: $input) {
      success
    }
  }`
